






import Vue from 'vue';
import mainContent from '@/components/page/home/index.vue';

export default Vue.extend({
    name: 'home',
    components: {
        mainContent
    }
});
